import { useField } from "formik";
import { PasswordInput as MantinePasswordInput } from "@mantine/core";
import { componentWrapper } from "../../utilities";
import styles from "./password-input.module.scss";
import type {
    CustomPasswordInputFactory,
    CustomPasswordInputFormikFactory,
    IPasswordInputFormikProps,
    IProps,
} from "./password-input.types";

const PasswordInput = componentWrapper<CustomPasswordInputFactory, IProps>("PasswordInput", (props, ref) => {
    return <MantinePasswordInput ref={ref} classNames={{ root: styles["container"] }} {...props} />;
});

const PasswordInputFormik = componentWrapper<CustomPasswordInputFormikFactory, IPasswordInputFormikProps>(
    "PasswordInputFormik",
    ({ name, validate, ...otherProps }, ref) => {
        const [field, meta] = useField({ name, validate });
        return <PasswordInput ref={ref} {...otherProps} error={meta.touched ? meta.error : undefined} {...field} />;
    }
);

PasswordInput.Formik = PasswordInputFormik;

export { PasswordInput, PasswordInputFormik };
